import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getRecipeById } from "../services/recipeServices";
import RecipeEditor from "../components/RecipeEditor";

const EditRecipe = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const fetchRecipe = async () => {
    return await getRecipeById(id);
  };

  const handleSaveComplete = () => {
    navigate(`/recipe/${id}`);
  };

  return (
    <RecipeEditor
      fetchRecipe={fetchRecipe}
      onSaveComplete={handleSaveComplete}
      pageTitle="Edit Recipe"
    />
  );
};

export default EditRecipe;
